import { Amount } from './amount.model';

export enum TRANSACTION_TYPES {
  deposit = 'deposit',
  withdrawal = 'withdrawal',
  transfer_out = 'transfer_out',
  transfer_in = 'transfer_in',
}

export const TRANSACTION_CAPTIONS: any = {
  deposit: 'Depósito',
  withdrawal: 'Retiro',
  transference: 'Transferencia',
  transfer_out: 'Transferencia enviada',
  transfer_in: 'Transferencia recibida',
  in_progress: 'En proceso',
  pending: 'Pendiente',
  not_processed: 'Cancelada',
  processed: 'Realizado',
};

export interface ICashTransactionResponse {
  account_id: string;
  legacy_contract_id: string;
  order_id: number;
  amount: Amount;
  process_date: string;
  order_type: string;
  transaction_status: string;
  target_account_id: string;
  source_account_id: string;
}

export interface PaginationMetadata {
  page: number;
  page_size: number;
  page_count: number;
  total_items: number;
  previous: string;
  next: string;
}

export interface ICashTransaction {
  accountId: string;
  legacyContractId: string;
  orderId: number;
  amount: Amount;
  processDate: string;
  orderType: string;
  transactionStatus: string;
  targetAccountId: string;
  sourceAccountId: string;
}

export class CashTransactionViewModel implements ICashTransaction {
  static fromJSON(json: ICashTransactionResponse): CashTransactionViewModel {
    return new CashTransactionViewModel(
      json.account_id,
      json.legacy_contract_id,
      json.order_id,
      json.amount,
      json.process_date,
      json.order_type,
      json.transaction_status,
      json.target_account_id,
      json.source_account_id,
    );
  }

  constructor(
    public accountId: string,
    public legacyContractId: string,
    public orderId: number,
    public amount: Amount,
    public processDate: string,
    public orderType: string,
    public transactionStatus: string,
    public targetAccountId: string,
    public sourceAccountId: string,
  ) {}
}
